import React from "react";
import { WizTableForm } from '@/containers/common'
const exam = WizTableForm.Config.exam(this, { apiParams: {statusList: [0,1] } })
const organization = { allowTreeSelect: true , ...WizTableForm.Config.organization(this)}
const position = WizTableForm.Config.position(this, { apiParams: { state: 1 } })
const user = WizTableForm.Config.user(this, { apiParams: { state: 1 } })
import moment from "moment";
const formatterDate = (val) => {
  return val ? moment(val).format('YYYY-MM-DD HH:mm') : '';
}

let formatTime = (time,record) => {
  let limitMinutesSeconds = record && record.limitMinutes ? record.limitMinutes * 60 : 0
  if(time > limitMinutesSeconds) {
    time = limitMinutesSeconds
  }
  // 转换为时分秒
  let h = parseInt(time / 60 / 60 % 24)
  let m = parseInt(time / 60 % 60)
  let s = parseInt(time % 60)
   let res = ''
   if (h > 0) {res += `${h}时`};
   if (m > 0) {res += `${m}分`};
   if (s > 0) {res += `${s}秒`};
  return res
}

//配置项
const componentName = "examReport";

function columns() {
  return [
    {
      name: "id",
    },
    {
      title: "考试名称",
      name: "title",
      tableItem: {},
    },
    {
      title: "考试名称",
      name: "examId",
      searchItem: {
        ...exam,
        diy: WizTableForm,
        selectType: 'radio',
        rules: [
          {
            required: true,
            message: '请选择考试名称'
          }
        ]
      },
    },
    {
      title: "考试分类名称",
      name: "examCategoryName",
      tableItem: {},
    },
    {
      title: "考试类型",
      name: "examType",
      tableItem: {
        render: (text, record) => {
          if(text=='0') {
            return '独立考试'
          } else if (text=='1'){
            return '课程考试'
          } else {
            return '独立考试、课程考试'
          }
        }
      },
    },
    {
      title: "考试状态",
      name: "status",
      tableItem: {},
      dict: [
        { code: 0, codeName: '草稿' },
        { code: 1, codeName: '已发布' },
        { code: 2, codeName: '已关闭' }
      ]
    },
    {
      title: "考试开始时间",
      name: "startDate",
      tableItem: {},
    },
    {
      title: "考试结束时间",
      name: "endDate",
      tableItem: {},
    },
    {
      title: "考试限制时长",
      name: "limitMinutes",
      tableItem: {},
    },
    {
      title: "学员账号",
      name: "account",
      tableItem: {},
    },
    {
      title: "学员姓名",
      name: "fullName",
      tableItem: {},
    },
    {
      title: "学员姓名",
      name: "personIds",
      searchItem: {
        ...user,
        diy: WizTableForm
      }
    },
  //  {
  //     title: "学员身份证",
  //     name: "idCard",
  //     tableItem: {},
  //   },
    {
      title: "账号状态",
      name: "accountState",
      searchItem: {
        type: 'select'
      },
      tableItem: {},
      dict: [
        { code: 1, codeName: '激活' },
        { code: 0, codeName: '禁用' }
      ]
    },
    {
      title: "组织名称",
      name: "orgName",
      tableItem: {},
    },
    {
      title: "组织名称",
      name: "orgIds",
      searchItem: {
        ...organization,
        diy: WizTableForm,
        onChangeRowMap: (e) => {},
      },
    },
    {
      title: "组织编码",
      name: "orgCode",
      tableItem: {},
    },
    {
      title: "组织类型",
      name: "orgTypeName",
      tableItem: {},
    },
    {
      title: "组织类型",
      name: "nodeCategoryIds",
      dict: {
        wizReplaceData: "orgNodeCategoryTree",
        defalutType: []
      },
      searchItem: {
        type: 'treeselect',
        treeCheckable: true
      }
    },
    {
      title: "上级组织",
      name: "leadName",
      tableItem: {},
    },
    {
      title: "上级组织",
      name: "parentOrgIds",
      searchItem: {
        ...organization,
        diy: WizTableForm
      },
    },
    {
      title: "省份",
      name: "province",
      dataIndex: "province",
      tableItem: {},
      searchItem: {
      },
    },
    {
      title: "岗位名称",
      name: "positionName",
      tableItem: {},
    },
    {
      title: "岗位",
      name: "positionIds",
      searchItem: {
        ...position,
        diy: WizTableForm
      },
    },
    {
      title: "任职状态",
      name: "jobState",
      searchItem: {
        type: 'select'
      },
      tableItem: {},
      dict: [
        { code: 1, codeName: '在职' },
        { code: 0, codeName: '离职' }
      ]
    },
    {
      title: '参考时间',
      name: 'examDate',
      dataIndex: "examDate",
      searchItem: {
        type: 'date~',
        showTime: true
      },
    },
    {
      title: "参加考试时间",
      name: "markingDate",
      tableItem: {
        render: (text) => {
          return formatterDate(text)
        }
      },
    },
    {
      title: "成绩得分",
      name: "score",
      tableItem: {},
    },
    {
      title: "考试通过状态",
      name: "pass",
      searchItem: {
        type: 'select'
      },
      tableItem: {},
      dict: [
        { code: 1, codeName: '通过' },
        { code: 0, codeName: '未通过' }
      ]
    },
    {
      title: "考试时长",
      name: 'duration',
      dataIndex: "duration",
      tableItem: {
        render : (text,record) => {
          return formatTime(text, record)
        }
      },
    },
  ];
}

function templateConfig() {
  return {
    mainProps: {},
    content: {
      name: "WizTableList",
      params: {
        columns: columns.call(this),
        searchBarProps: {
          buttonSort:['export'],
          buttons: [
            {
              key: 'export',
              custom: true,
              params: { icon: 'export', children: '导出', type: 'export'},
              customOnClick: {
                key: 'action',
                params: {
                  apiKey: "export",
                  apiParams: {}
                },
                formatParams:(rows,record,filters,callback)=>{
                  return {...filters}
                }
              }
            }
          ],
          dataFormat: (v) => {
            let value = Object.assign({}, v)
            if (value['nodeCategory'] && value['nodeCategory'].length) {
              value['nodeCategoryIds'] = value['nodeCategory'].map(nodeCategory => nodeCategory.value)
            } else {
              value['nodeCategoryIds'] = undefined
            }
            return value
          },
          dataFormat: (params) => {
            let value = Object.assign({}, params)
            if (value.examDate && value.examDate.length === 2) {
              value.startDate = value.examDate[0].format('YYYY-MM-DD HH:mm:ss')
              value.endDate = value.examDate[1].format('YYYY-MM-DD HH:mm:ss')
            }
            return value
          },
        },
        modalFormProps: {},
        dataTableProps: {
          rowKey: (record, index) => index,
          isScroll: true,
          loading: false,
        }
      },
    },
  };
}

const apis = {
  list: {
    path: `${componentName}/getPageList`,
    payload: {
      key: `${componentName}@getPageList`,
      apiParams: { pageNum: 1, pageSize: 10 },
    },
  },
  export: {
    path: `${componentName}/export`,
    payload: {
      key: `${componentName}@export`,
      apiParams: {}
    }
  },
  orgNodeCategoryTree: {
    path: `organizationNodeCategory/getTypeNodeList`,
    payload: {
      key: `${componentName}@orgNodeCategoryTree`,
      apiParams: {}
    }
  },
};

let reduxTemplateCofig = (args) => {
  return {
    apis,
    componentName,
    initApiKeys: ["list", "orgNodeCategoryTree"],
    needLoading: true,
    ...args,
  };
};

export { reduxTemplateCofig, templateConfig };
